module.exports = __webpack_public_path__ + "img/data-item1-2.c1ed427.png";